module.exports = __webpack_public_path__ + "static/media/4.ce4327c0.jpg";